/* @flow */

import React from "react";
import { useTranslate } from "@awardit/react-use-translate";
import cn from "classnames";
import styles from "./styles.scss";
import MainLogo from "../logo.svg";

type Props = {
  className?: string,
};

const Logo = ({ className, ...props }: Props) => {
  const t = useTranslate();

  return (
    <div {...props} className={cn(styles.block, className)}>
      <MainLogo
        alt={t("LOGO.ALT")}
        aria-label={t("LOGO.TITLE")}
        className={styles.logoMain}
      />

      <span className={styles.eurobonus}>
        {t("HEADER.SHOPNAME")}
      </span>
    </div>
  );
};

export default Logo;
